<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <div>
          <Caption label="파트너쉽 레퍼런스"></Caption>
        </div>
        <ul>
          <li v-for="m of list">
            <SectionPartnerReferenceItem
              :record="m"
              :id="m.id"
              :image="m.image"
              :text1="m.name"
              :text2="m.sub_text"
              :text3="m.desc"
            />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import CaptionWhite from "./CaptionWhite.vue";
import SectionPartnerReferenceItem from "./SectionPartnerReferenceItem.vue";
import client from "../client/client";

export default {
  components: {
    Caption,
    CaptionGreen,
    CaptionWhite,
    SectionPartnerReferenceItem,
  },
  mounted() {
    client
      .get("/api/portfolio/list?partner=true")
      .then((res) => {
        this.list = res.list;
        // this.list = this.list.splice(0, 2);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  data() {
    return {
      list: [],
    };
  },
};
</script>
  
<style scoped>
.content_bg {
  width: 100vw;
  height: fit-content;
  position: relative;
  padding-top: 0px;
  padding-bottom: 0px;
  background-color: #ffffff;
}

.content {
  width: 100%;
  max-width: 100%;
  text-align: center;
  padding: 0;
}

ul {
  margin-top: 50px;
  width: 100%;
  list-style-type: none;
  display: block;
  padding:0;
}
li:not(:last-child) {
}

ul li {
  display: block;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    justify-content: center;
    width: 100%;
    height: fit-content;
    position: relative;
  }

  .content {
    width: 100%;
    text-align: center;
  }

  ul {
    text-align: center; 
    display: block; 
    justify-content: center;
    width: 100%;
    height: fit-content;
    list-style-type: none;
    padding-inline-start: 0px;
  }

  ul li {
    display: block;
  }
}
</style>
  